import Nullstack from 'nullstack';
export default function IconUsb({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-usb",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M12 17v-11.5"
  }), "   ", Nullstack.element("path", {
    d: "M7 10v3l5 3"
  }), "   ", Nullstack.element("path", {
    d: "M12 14.5l5 -2v-2.5"
  }), "   ", Nullstack.element("path", {
    d: "M16 10h2v-2h-2z"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "9",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M10 5.5h4l-2 -2.5z"
  }), " ");
}